import { createPushModal } from 'pushmodal';
import { ConfirmReservationWithTagModal } from './confirm-reservation-with-tag-modal';
import { ConfirmationModal } from './confirmation-modal';
import { CreateAgendaSlotBulkReportModal } from './create-agenda-slot-bulk-report-modal/create-agenda-slot-bulk-report-modal';
import { DeleteAgendaSlotRecurrenceModal } from './delete-agenda-slot-recurrence-modal/delete-agenda-slot-recurrence-modal';
import { DeleteWorkScheduleSlotRecurrenceModal } from './delete-work-schedule-slot-recurrence-modal/delete-work-schedule-slot-recurrence-modal';
import { ExportAccountingTransferOrderModal } from './export-accounting-transfer-order-modal/export-accounting-transfer-order-modal';
import { GenerateOfficeDoctorAttendingAccountingModal } from './generate-office-doctor-attending-accounting-modal/generate-office-doctor-attending-accounting-modal';
import { ImportAccountingDoctorAttendingCsvDazzModal } from './import-accounting-doctor-attending-csv-dazz-modal/import-accounting-doctor-attending-csv-dazz-modal';
import { ImportAccountingDoctorAttendingCsvModal } from './import-accounting-doctor-attending-csv-modal/import-accounting-doctor-attending-csv-modal';
import { ImportAccountingDoctorAttendingCsvReportModal } from './import-accounting-doctor-attending-csv-report-modal/import-accounting-doctor-attending-csv-report-modal';
import { MoveAgendaSlotModal } from './move-agenda-slot-modal/move-agenda-slot-modal';
import { NotificationModal } from './notification-modal';
import { OccupationReportModal } from './occupation-report-modal/occupation-report-modal';
import { ViewDoctolibImportModal } from './view-doctolib-import-modal/view-doctolib-import-modal';

// KNOWN: adding a 15th entry to this map tipped TypeScript past a generic-
// inference threshold and triggered TS2742 portability cascades across this
// file plus sheets/index.ts, templates/index.ts, ui/command.tsx, ui/form.tsx,
// and ui/chart.tsx. The runtime is unaffected and `vite build` succeeds.
// Suppressing requires either (a) upgrading pushmodal to ship explicit return
// types, (b) adding `"declaration": false` and a portability override to the
// shared tsconfig, or (c) splitting modals into multiple createPushModal call
// sites — splitting was tried and made the cascade worse.
export const {
  pushModal,
  popModal,
  popAllModals,
  replaceWithModal,
  useOnPushModal,
  onPushModal,
  ModalProvider,
} = createPushModal({
  modals: {
    ConfirmationModal,
    ConfirmReservationWithTagModal,
    NotificationModal,
    DeleteAgendaSlotRecurrenceModal,
    DeleteWorkScheduleSlotRecurrenceModal,
    ImportAccountingDoctorAttendingCsvDazzModal,
    ImportAccountingDoctorAttendingCsvModal,
    ImportAccountingDoctorAttendingCsvReportModal,
    ExportAccountingTransferOrderModal,
    GenerateOfficeDoctorAttendingAccountingModal,
    CreateAgendaSlotBulkReportModal,
    OccupationReportModal,
    MoveAgendaSlotModal,
    ViewDoctolibImportModal,
  },
});
